"use strict";

const _ = require('underscore');
const Backbone = require('dibs-backbone');
const SoaModel = require('bunsen/models/SoaModel');
const endpoints = require('dibs-endpoints');
const assert = require('bunsen/helpers/assert');
const SD = require('simply-deferred').Deferred;
const IMAGE_API_TYPE = 'image';

const Photo = SoaModel.extend();

_.extend(Photo, {
    UPLOAD_TYPE_DEALER: 'USER',
    UPLOAD_TYPE_1STDIBS: '_1STDIBS'
});

_.extend(Photo.prototype, {
    relations: [
        {
            key: 'versions',
            type: Backbone.Many,
            relatedModel: SoaModel.extend({
                relations: [
                    {
                        key: 'type',
                        type: Backbone.One,
                        relatedModel: SoaModel
                    }
                ]
            })
        }
    ],

    download: function (options) {
        const item = this.collection && this.collection.parents[0];
        if (!item || item.get('id') === undefined) {
            const message = 'Cannot download photo that does not have an item parent with an id';
            console.error(message);
            return new SD().reject(message);
        }
        options = options || {};
        const params = this.getTokenObj();
        params.version = options.version || 'original';
        const url = endpoints.downloadOriginal(item.get('id'), this.get('id'));

        location.href = `${url}?${Backbone.$.param(params)}`;
    },

    initialize(attributes) {
        attributes.apiType = IMAGE_API_TYPE;
        this.set('apiType', IMAGE_API_TYPE);
        return Photo.__super__.initialize.call(this, attributes);
    },

    /**
     * Determines if the photo in question is the first photo.
     * @returns {boolean}
     */
    isPhotoOne() {
        return this.get('sortOrder').toString() === '1';
    },

    /**
     * Returns who uploaded the image
     * @returns string
     */
    getPhotoProvider() {
        const provider = this.get('uploadType');
        if (provider === this.UPLOAD_TYPE_DEALER) {
            return 'dealer';
        } else if (provider === this.UPLOAD_TYPE_1STDIBS) {
            return '1stdibs';
        }
        return null;
    },

    /**
     * Returns photo version by type, if exists
     * @param {string} type
     * @returns Object
     */
    getVersion(type) {
        if (this.get('versions')) {
            return _.first(this.get('versions').filter(version => {
                return version.get('type.name') === type;
            }));
        }
    },

    /**
     * Rotate a photo on the item.
     * @param newAngle - <number>
     * @returns {Deferred}
     */
    rotatePhoto(newAngle) {
        assert(newAngle, 'You must include an angle of rotation.');
        let xhr;
        const rotateData = {
            apiType : Photo.PHOTOS_API.PHOTOS_ROTATION_API_TYPE,
            type : Photo.PHOTOS_API.PHOTOS_ROTATION_TYPE,
            degree : newAngle
        };
        const parent = this.collection && this.collection.parents ? this.collection.parents[0] : null;
        const _trigger = function (e) {
            this.trigger(e);
            if (parent && (typeof parent.trigger === 'function')) {
                parent.trigger(e);
            }
        }.bind(this);

        xhr = this.save(null, {
            url: endpoints.processImage(this.collection.parents[0].get('id'), this.get('id')),
            data: JSON.stringify(rotateData),
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=UTF-8',
            success() { return _trigger('photo-model-rotation-success'); },
            error() { return _trigger('photo-model-rotation-fail'); }
        });

        _trigger('photo-model-rotation-start', xhr);
        return xhr;
    }
});

// Static functions
_.extend(Photo, {
    PHOTOS_API : {
        PHOTOS_ROTATION_API_TYPE : 'imageRotationRequest',
        PHOTOS_ROTATION_TYPE : 'ROTATION'
    }
});

module.exports = Photo;



// WEBPACK FOOTER //
// ./~/bunsen/models/inventory/Photo.es.js